import { useEffect, useRef } from 'react';
function useRunAfterUpdate() {
    const afterPaintRef = useRef();
    useEffect(() => {
        var _a;
        if (afterPaintRef.current) {
            (_a = afterPaintRef.current) === null || _a === void 0 ? void 0 : _a.call(afterPaintRef);
            afterPaintRef.current = undefined;
        }
    });
    return (fn) => (afterPaintRef.current = fn);
}
export { useRunAfterUpdate };
//# sourceMappingURL=useRunAfterUpdate.js.map